import { createAction } from 'redux-act';
import { TErrors } from '@alycecom/services';

import { TImageName, BgOptions, IUploadImageParams, TBrandingImage } from '../types/Branding.types';
import { IBranding, IBrandingParams, IBrandingColorParams } from '../../../types/Branding.types';

const PREFIX = 'BRANDING';

export const applyBrandingFields = createAction<IBrandingColorParams>(`${PREFIX}/APPLY_BRANDING_FIELDS`);

export const applyBrandingImages = createAction<{ name: TImageName; image: TBrandingImage }>(
  `${PREFIX}/APPLY_BRANDING_IMAGE`,
);

export const uploadImageRequest = createAction<IUploadImageParams>(`${PREFIX}/UPLOAD_IMAGE_REQUEST`);
export const uploadImageSuccess = createAction<{ id: number; url: string; name: TImageName }>(
  `${PREFIX}/UPLOAD_IMAGE_SUCCESS`,
);
export const uploadImageFail = createAction<TErrors>(`${PREFIX}/UPLOAD_IMAGE_FAIL`);

export const updateBrandingRequest = createAction<{
  values: IBrandingParams;
  logoId: number;
  bgId: number;
  brandingOwner?: string;
}>(`${PREFIX}/UPDATE_BRANDING_REQUEST`);
export const updateBrandingSuccess = createAction<IBranding>(`${PREFIX}/UPDATE_BRANDING_SUCCESS`);
export const updateBrandingFail = createAction<TErrors>(`${PREFIX}/UPDATE_BRANDING_FAIL`);

export const setupInitialBranding = createAction<IBranding>(`${PREFIX}/SETUP_INITIAL_BRANDING`);
export const resetBrandingChanges = createAction<IBranding>(`${PREFIX}/RESET_BRANDING_CHANGES`);

export const setBackgroundOption = createAction<BgOptions>(`${PREFIX}/SET_BACKGROUND_OPTION`);
